(function ($) {
  if (!$('body').hasClass('page-template-skoda-tour-de-france-2025')) {
    return;
  }

  $('.beforeAfter').beforeAfter({
    opacity: 1,
    activeOpacity: 1,
    hoverOpacity: 1,
  });
})(jQuery);
